// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ProfilePicController from "./profile_pic_controller"
application.register("profile-pic", ProfilePicController)

import WeekdayController from "./weekday_controller"
application.register("weekday", WeekdayController)

import TimeAgoController from "./time_ago_controller"
application.register("time-ago", TimeAgoController)